import { render, staticRenderFns } from "./PublicParticipation.vue?vue&type=template&id=3da666b6"
import script from "./PublicParticipation.vue?vue&type=script&lang=js"
export * from "./PublicParticipation.vue?vue&type=script&lang=js"
import style0 from "./PublicParticipation.vue?vue&type=style&index=0&id=3da666b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports